import { useMemo } from "@wordpress/element";

export const useStyleBuilder = (styleMap) => {
    return useMemo(() => {
        const styles = {};

        Object.entries(styleMap).forEach(([cssProperty, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                styles[cssProperty] = value;
            }
        });

        return Object.keys(styles).length ? styles : undefined;
    }, [styleMap]);
};
